import { Drawer } from "@JohnLewisPartnership/jl-design-system/dist/components/drawer/Drawer";
import ingredientDetailStyles from "@/components/Ingredients/components/IngredientDetail/IngredientDetail.module.scss";

export type DrawerProps = {
  isOpen: boolean;
  handleClose: () => void;
  badgeHeader: string;
  description: string[];
};

export const GoodToKnowDrawer = ({
  isOpen,
  handleClose,
  badgeHeader,
  description,
}: DrawerProps) => {
  return (
    <Drawer isOpen={isOpen} onClose={handleClose} heading={badgeHeader}>
      {description.map((para: string, i: number) => (
        <p key={i}>{para}</p>
      ))}
      <p className={ingredientDetailStyles.poweredBy}>
        Powered by Skin Match Technology
      </p>
    </Drawer>
  );
};
